import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      storeIgua.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function rnhFilterOptionsReducer(
	state = initialState.rnhFilterOptions,
	action
) {
	switch (action.type) {
		case types.GET_FILTER_OPTIONS: {
			let options = _.cloneDeep(state);
			options[
				options.findIndex((option) => option.filterType === action.filter)
			].values = action.response.users.map((item) => {
				return {id: item.userId, label: `${item.firstName} ${item.lastName}`};
			});
			return options;
		}
		case types.CLEAN_FILTER_OPTIONS: {
			return initialState.rnhFilterOptions;
		}
		default:
			return state;
	}
}
